import { css } from '@emotion/core';
import styled from '@emotion/styled';

export const BarWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  height: 100%;
  align-items: center;

  & p {
    color: var(--color-font-white);
    padding-left: 10px;

    &.darken {
      color: var(--color-font-primary);
    }
  }
`;

export const BarInner = styled.div`
  width: ${({ widthPercent }) => widthPercent ?? 100}%;
  height: 100%;
  background: var(--color-button-warning-hover);
  ${({ color }) => css`
    background-color: ${color.color};
    opacity: ${color.opacity};
  `}
  display: flex;
  align-items: center;
`;
